<template>
    <div class="donate-cta">
        <h1 class="donate-heading">Every animal deserves a loving home.</h1>
    <h2 class="donate-title">Please join us in supporting the Berrien County Animal Control</h2>
   <p class="donate-description">
        Your donation helps provide food, shelter, and medical care for animals in need. Join us in making a difference!
      </p>
      <div class="donate-section">
        <div class="donate-image">
          <img src="@/assets/JDawg.jpg" alt="Doggo" style="width: 250px; height: auto;" />
        </div>

        <a href="https://www.berriencounty.org/224/Donate" 
        target="_blank" 
        rel="noopener noreferrer"
        class="donate-button"> Donate Now</a>

      <a href="https://www.berriencounty.org/FormCenter/Animal-Control-Encrypted-31/Volunteer-Application-196" 
            target="_blank" 
            rel="noopener noreferrer"
            class="volunteer-button">
            Volunteer </a>
    </div>
        
      


    </div>
  </template>
  
  <script>
  export default {
    name: "DonateCTA",
  };
  </script>
  
  <style scoped>
  .donate-cta {
    background: transparent;
    text-align: center;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .donate-heading{
    font-size: 2.5em;
    color: #fff;
    margin-bottom: 20px;
    text-shadow: 2px 2px 0px #000000;
    letter-spacing: 2px;
  }
  .donate-title {
    font-size: 1.8em;
    color: #fff;
    margin-bottom: 10px;
  }
  
  .donate-description {
    font-size: 1.2em;
    color: #fff;
    margin-bottom: 20px;
  }
  
  .donate-button {
    display: inline-block;
    padding: 10px 20px;
    font-size: 1em;
    color: #fff;
    background-color: #007bff;
    text-decoration: none;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }
  
  .donate-button:hover {
    background-color: #0056b3;
  }
  .volunteer-button {
    display: inline-block;
    padding: 10px 20px;
    font-size: 1em;
    color: #fff;
    background-color: #007bff;
    text-decoration: none;
    border-radius: 5px;
    transition: background-color 0.3s ease;
    margin: 10px 5px;
}

.donate-button:hover,
.volunteer-button:hover {
    background-color: #0056b3;
}
  </style>